import React, { useState, useMemo }  from 'react'
import { Container, Form, Button, Image, Row, Col, Nav, NavDropdown, Table } from 'react-bootstrap';
import { Search, Filter, Calendar, DollarSign, AlertTriangle, CheckCircle2, Clock, Target, TrendingUp, FileText } from 'lucide-react';
import SideNav from '../components/SideNav';
import StepProgress from '../components/StepProgress';
import OrdersPage from './OrderPage';
import ProjectList from '../components/ProjectList';
import NotificationDropdown from '../components/NotificationDropdown'; // New notification component
import './ReportProjectOverview.css'
import Filters from '../components/Filters';
import CollapsibleTable from '../components/CollapsibleTable';
import { useDesignerDetails } from '../hooks/useDesignerDetails';



function DesignersOverview() {

  const userUId = window.localStorage.getItem('projectUserUID');
    const userRole = window.localStorage.getItem('projectUserRole');

        const { isLoading, isError, error, data } = useDesignerDetails(userUId, userRole);
   
  const [searchTerm, setSearchTerm] = useState('');
    const [selectedStage, setSelectedStage] = useState('');
    const [completionFilter, setCompletionFilter] = useState('');



  return (
       <Container fluid className='p-3' style={{ backgroundColor: "#F9FAFB", height: "100vh", }}>
               <Row>
                   <Col className='col-auto'>
                      <SideNav />
                   </Col>
                   <Col style={{ padding: "0px 10px 0px 20px",flexGrow:1}}>
                       <Row className='p-2' style={{ backgroundColor: "#fff", borderRadius: '10px', alignItems: "center", justifyContent: "spaceBetween" }}>
                           <Col><h4 style={{ color: "#000" }}>Designers Overview</h4></Col>
                           <Col className="d-flex justify-content-end align-items-center">
                           {/* <NotificationDropdown userId={userUId} /> */}
                               {/* <Image src={require('../assets/notification.png')} roundedCircle style={{ width: '25px', height: 'auto', marginRight: '5px', }} /> */}
                               <Image src={require('../assets/user.jpg')} roundedCircle style={{ width: '40px', height: 'auto' }} />
                           </Col>
                       </Row>
                       <Row className='p-2 mt-2' style={{  borderRadius: '10px', alignItems: "center", justifyContent: "spaceBetween" }}>
                          
                               {/* Filters */}
           {/* <Filters  selectedStage={selectedStage} setSelectedStage={setSelectedStage} completionFilter={completionFilter} setCompletionFilter={setCompletionFilter} uniqueStages ={uniqueStages }  /> */}
            <CollapsibleTable designerData={data} loading={isLoading}/>
                     
                       </Row>
   
                   </Col>
               </Row>
           </Container>
     )
   }


export default DesignersOverview